<ng-container *ngIf="!showExport">
  <payarc-page-header title="PayPal Transactions" subtitle="Payments processed through your connected PayPal account."></payarc-page-header>

  <app-payment-tabs></app-payment-tabs>

  <payarc-filter-bar class="pp-filter-row">
    <payarc-search placeholder="Search by PayPal ID, customer" [value]="searchText" (valueChange)="searchText = $event; searchHits.next()"></payarc-search>
    <input [matDatepicker]="dp" (dateChange)="checkdate()" (click)="dp.open()" [(ngModel)]="from_date" [max]="today"
           class="pa-input" style="width:150px" placeholder="From" aria-label="From date" readonly>
    <mat-datepicker #dp (closed)="datereport()"></mat-datepicker>
    <input [matDatepicker]="dp1" (dateChange)="checkdate2()" (click)="dp1.open()" [(ngModel)]="to_date" [max]="today"
           class="pa-input" style="width:150px" placeholder="To" aria-label="To date" readonly>
    <mat-datepicker #dp1 (closed)="datereport()"></mat-datepicker>
    <button actions type="button" payarcButton="primary" (click)="openexcel()">Export</button>
  </payarc-filter-bar>

  <payarc-section-card [flush]="true">
    <payarc-table>
      <thead>
        <tr>
          <th class="num" [attr.aria-sort]="sortAriaFor('amount')">
            <button type="button" class="pa-th-sort" (click)="setSorting('amount')">Amount
              <payarc-sort-icon [direction]="sortDirectionFor('amount')"></payarc-sort-icon></button></th>
          <th>Type</th>
          <th>Internal (Payarc) ID</th>
          <th>PayPal ID</th>
          <th>Status</th>
          <th>Customer Name</th>
          <th>Customer Email</th>
          <th [attr.aria-sort]="sortAriaFor('created_at')">
            <button type="button" class="pa-th-sort" (click)="setSorting('created_at')">Transaction Date
              <payarc-sort-icon [direction]="sortDirectionFor('created_at')"></payarc-sort-icon></button></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="loadFlag">
          <tr class="pa-skeleton-row" *ngFor="let r of [1,2,3,4,5]">
            <td *ngFor="let c of [1,2,3,4,5,6,7,8]"><span class="pa-skeleton-bar"></span></td>
          </tr>
        </ng-container>

        <tr *ngIf="!loadFlag && errorMsg">
          <td class="pa-table__state-cell" colspan="8">
            <payarc-empty-state title="No PayPal transactions found" [message]="errorMsg"></payarc-empty-state>
          </td>
        </tr>

        <ng-container *ngIf="!loadFlag && !errorMsg">
          <tr *ngFor="let record of transactionsList.data" class="cursor" [routerLink]="redirectToDetails()" [queryParams]="{id: record.id}">
            <td class="num strong" [innerHTML]="record.amount ? ((highlight(record.amount | currency:(record.currency || 'USD'):'symbol':'1.2-2')) + ' ' + (record.currency || 'USD')) : '--'"></td>
            <td>{{ record.type }}</td>
            <td>{{ record.id }}</td>
            <td [innerHTML]="record.paypal_id ? highlight(record.paypal_id) : '--'"></td>
            <td>{{ record.status }}</td>
            <td>{{ record.customer_name }}</td>
            <td>{{ record.customer_email }}</td>
            <td>{{ record.created_at | date : 'MM/dd/yyyy hh:mm' }}</td>
          </tr>
        </ng-container>
      </tbody>
    </payarc-table>

    <div class="pp-pager-row" *ngIf="!loadFlag && !errorMsg && metadata?.['total']">
      <payarc-pager
        [rangeLabel]="pagerRangeLabel"
        [pages]="pagerPages"
        [currentPage]="currentPage"
        [disablePrev]="currentPage <= 1"
        [disableNext]="currentPage >= totalPages"
        (prev)="pagerPrev()"
        (next)="pagerNext()"
        (pageSelect)="pagerSelect($event)"
      ></payarc-pager>
    </div>
  </payarc-section-card>
</ng-container>

<div class="table-content export_content" *ngIf="showExport">
  <app-export-excel [exportExcel]="exportExcel" [serviceName]="exportData" [searchData]="searchText"></app-export-excel>
</div>
